import IFinancialModel from './IFinancialModel'

export class FinancialModelBase extends IFinancialModel {
  constructor(dataStore) {
    super(dataStore)
    this.dataStore = dataStore
  }

  // Returns a promise
  createForecast(forecast) {
    return this.dataStore.createForecast(forecast)
  }

  // Returns a promise
  storeForecast(forecastId, forecast) {
    return this.dataStore.storeForecast(forecastId, forecast)
  }

  // Returns a promise
  retrieveForecast() {
    return this.dataStore.retrieveForecast()
  }

  // Returns a promise
  removeForecast(forecastId) {
    return this.dataStore.removeForecast(forecastId)
  }

  // Returns a promise
  storeEqValuation(companyId, eqValuation) {
    return this.dataStore.storeEqValuation(companyId, eqValuation)
  }

  // Returns a promise
  retrieveEqValuation(companyId) {
    return this.dataStore.retrieveEqValuation(companyId)
  }
  
}

export default FinancialModelBase
